'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUploadCompleted = undefined;

var _fileUploadGetters = require('./fileUploadGetters');

var isUploadCompleted = exports.isUploadCompleted = function isUploadCompleted(attachment) {
  var fileId = (0, _fileUploadGetters.getFileId)(attachment);

  return fileId !== -1;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/file-upload/operators/isUploadCompleted.js
// module id = 238
// module chunks = 2 3